import { useRouter } from "next/router";
import Variables from "../../variables/variables.json";
import { Preloader } from "../../components/Preloader";
import Head from "next/head";
import dynamic from "next/dynamic";

import Password from "../Password";

const componentMap = {
	index: dynamic(() => import("./_index")),
	kontakt: dynamic(() => import("./kontakt/_kontakt")),
	deklaracja: dynamic(() => import("./deklaracja-dostepnosci/_deklaracja")),
	mapastrony: dynamic(() => import("./mapa-strony/_mapastrony")),
	transportowe: dynamic(() => import("./podatek-od-srodkow-transportowych/_transportowe")),
	nieruchomosci: dynamic(() => import("./podatek-od-nieruchomosci/_nieruchomosci")),
	rolny: dynamic(() => import("./podatek-rolny/_rolny")),
	lesny: dynamic(() => import("./podatek-lesny/_lesny")),
	odpadykomunalne: dynamic(() =>
		import("./oplata-za-gospodarowanie-odpadami-komunalnymi/_odpadykomunalne"),
	),
};

const pathMap = {
	index: "",
	kontakt: "kontakt/",
	deklaracja: "deklaracja-dostepnosci/",
	mapastrony: "mapa-strony/",
	transportowe: "podatek-od-srodkow-transportowych/",
	nieruchomosci: "podatek-od-nieruchomosci/",
	rolny: "podatek-rolny/",
	lesny: "podatek-lesny/",
	odpadykomunalne: "oplata-za-gospodarowanie-odpadami-komunalnymi/",
};

export default function RouterLayout({ Podatek }) {
	const router = useRouter();

	if (!router.isReady) {
		return null;
	}

	const siteCode = router.query.siteCode;
	const cityConfig = Variables.citiesConfig.find((city) => city.siteCode === siteCode);

	const ComponentShow = componentMap[Podatek];
	const RouterRedirect = pathMap[Podatek] ?? "";

	if (cityConfig) {
		const Miasto = cityConfig.variableName;

		return (
			<>
				<Head>
					<link rel="canonical" href={`https://przyjazne-deklaracje.pl/${RouterRedirect}`} />
				</Head>

				{Variables.miasta[Miasto]?.password ? (
					<Password>
						<ComponentShow miasto={Miasto} podatek={Podatek} />
					</Password>
				) : (
					<ComponentShow miasto={Miasto} podatek={Podatek} />
				)}
			</>
		);
	}

	return <Preloader redirect={RouterRedirect} />;
}
